import gql from 'graphql-tag';

export const removeClaManagerMutation = gql`
  mutation removeClaManager($input: removeClaManagerInput!) {
    removeClaManager(input: $input) {
      code
      message
      success
    }
  }
`;
